export class AgentAssignmentError extends Error {
  constructor(code) {
    super(code);
    this.code = code;
  }
}

export const agentAssignmentValue = (agent = {}) => {
  if (agent.permission_set_id != null && agent.custom_role_id != null) {
    throw new AgentAssignmentError('conflicting_assignment');
  }
  if (agent.role === 'administrator') return 'administrator';
  if (agent.permission_set_id != null) {
    return `permission_set:${agent.permission_set_id}`;
  }
  if (agent.custom_role_id != null) return `native:${agent.custom_role_id}`;
  return 'agent';
};

export const agentAssignmentPayload = ({
  selection,
  previous,
  ownEnabled,
  nativeEnabled,
  enterprise,
}) => {
  const initial = agentAssignmentValue(previous);
  const payload = {
    agent: {},
    ...(enterprise ? { custom_role_id: previous?.custom_role_id ?? null } : {}),
  };
  if (previous && selection === initial) return payload;
  // Promotion clears the own binding on the server even with its management off.
  if (selection === 'administrator') {
    payload.agent.role = 'administrator';
    if (enterprise) payload.custom_role_id = null;
    return payload;
  }

  const match = /^(permission_set|native):([1-9]\d*)$/.exec(selection);
  if (
    selection !== 'agent' &&
    (!match || !Number.isSafeInteger(Number(match[2])))
  ) {
    throw new AgentAssignmentError('invalid_selection');
  }
  const source = match?.[1];
  if (
    (source === 'permission_set' || previous?.permission_set_id != null) &&
    !ownEnabled
  ) {
    throw new AgentAssignmentError('own_unavailable');
  }
  if (
    (source === 'native' || previous?.custom_role_id != null) &&
    !(enterprise && nativeEnabled)
  ) {
    throw new AgentAssignmentError('native_unavailable');
  }

  payload.agent.role = 'agent';
  if (source === 'permission_set')
    payload.agent.permission_set_id = Number(match[2]);
  else if (previous?.permission_set_id != null)
    payload.agent.permission_set_id = null;
  if (enterprise)
    payload.custom_role_id = source === 'native' ? Number(match[2]) : null;
  return payload;
};
